module.exports = __webpack_public_path__ + "static/media/logo.e90a4936.jpg";